<script setup lang="ts">
import type { Component } from 'vue';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

defineProps<{
    modelValue: string;
    options: Array<{
        value: string;
        label: string;
        icon: Component;
    }>;
    label: string;
}>();

const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void;
}>();
</script>

<template>
    <TooltipProvider :delay-duration="250">
        <div class="inline-flex items-center rounded-lg border border-border/70 bg-background/80 p-0.5" role="group" :aria-label="label">
            <Tooltip v-for="option in options" :key="option.value">
                <TooltipTrigger as-child>
                    <Button
                        type="button"
                        size="icon-sm"
                        :variant="modelValue === option.value ? 'secondary' : 'ghost'"
                        class="size-7 rounded-md"
                        :aria-label="option.label"
                        :aria-pressed="modelValue === option.value"
                        @click="emit('update:modelValue', option.value)"
                    >
                        <component :is="option.icon" class="size-3.5" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>{{ option.label }}</TooltipContent>
            </Tooltip>
        </div>
    </TooltipProvider>
</template>
